export default {
    created() {
        if (this.$root.params) {
            if ('sort' in this.$root.params) {
                let sort = this.$root.params.sort.split('|');

                this.$set(this.sortOrder[0], 'field', sort[0]);
                this.$set(this.sortOrder[0], 'sortField', sort[0]);
                this.$set(this.sortOrder[0], 'direction', sort[1]);
            }

            if ('page' in this.$root.params && !isNaN(this.$root.params.page) && Number(this.$root.params.page) > 0) {
                this.$set(this, 'initialPage', Number(this.$root.params.page));
            }

            if ('per_page' in this.$root.params && !isNaN(this.$root.params.per_page) && Number(this.$root.params.per_page) > 0) {
                this.$set(this, 'perPage', Number(this.$root.params.per_page));
            }

            if (this.filterBy) {
                for (let keyword of this.filterBy) {
                    if (keyword in this.$root.params && this.$root.params[keyword] !== '') {
                        this.$set(this.moreParams, keyword, this.$root.params[keyword]);
                    }
                }
            }
        }
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/TableUrlParams.js